module.exports = __webpack_public_path__ + "img/staff.24e5ccd8.jpg";